import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=73845632"
import script from "./adminList.vue?vue&type=script&lang=js"
export * from "./adminList.vue?vue&type=script&lang=js"
import style0 from "./adminList.vue?vue&type=style&index=0&id=73845632&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports